<template>
  <CFooter>
    <div v-if="subscription">
      <div v-if="!subscription.isTrial">
        <span class="ms-1" :style="getStyleObject(subscription.planExpiresAt)"
          >Plan <b>{{ subscription.planName }}</b> valable jusqu'au
          <b>{{ formattedDate(subscription.planExpiresAt) }}</b></span
        >
      </div>
      <div v-if="subscription.isTrial">
        <span class="ms-1" :style="getStyleObject(subscription.endDate)"
          >Essai gratuit valable jusqu'au
          <b>{{ formattedDate(subscription.endDate) }}</b></span
        >
      </div>
      <!-- <div class="ms-auto">
      <span class="me-1" target="_blank">Réalisé par</span>
      <a href="https://nextdevninja.com" target="_blank">NextDev</a>
    </div> -->
    </div>
  </CFooter>
</template>

<script>
import { mapGetters } from 'vuex'
import format from 'date-fns/format'
export default {
  name: 'AppFooter',
  computed: {
    ...mapGetters('subscription', ['subscription']),
  },
  methods: {
    getSubscription() {
      this.$store.dispatch('subscription/getSubscription').catch((error) => {
        console.error('Error fetching subscription:', error)
      })
    },
    formattedDate(date) {
      return format(new Date(date), 'dd/MM/yyyy')
    },
    getStyleObject(date) {
      const planExpirationDate = new Date(date)
      const currentDate = new Date()
      const differenceInDays = Math.abs(
        (planExpirationDate - currentDate) / (24 * 60 * 60 * 1000),
      )
      if (differenceInDays > 7) {
        return {
          color: '#618c7f', // green
        }
      } else {
        return {
          color: '#e55353', // red
        }
      }
    },
  },
  mounted() {
    this.getSubscription()
  },
}
</script>
